import React from "react";
import Button from "../components/button/Button";
import Subtitle from "../components/subtitle/Subtitle";
import Paragraph from "../components/paragraph/Paragraph";
import Header from "../components/header/Header";
import UpperHeader from "../components/header/UpperHeader";
import Footer from "../components/footer/Footer";
import Image from "../components/image/Image";

const Sponsorship: React.FC = () => {
  const bulletPoints = [
    "大会に出場する際にかかる登録費や参加費などの大会出場費",
    "研究に使う資材やデータ等の購入に充てる研究費",
    "教育活動(*2)にかかる費用",
  ];

  return (
    <div>
      <UpperHeader />

      <Header pageTitle="ご協賛のお願い" />

      <Subtitle text="ご支援のお願い" />

      <Paragraph text="　皆様へ、改めまして大切なご連絡がございます。それはiGEM TSUKUBAおよびiGEMチーム全体に関わる、資金の問題についてです。iGEMとは合成生物学(遺伝子工学などを用いて生物の改良を目指す分野)の世界大会です。iGEM TSUKUBAは筑波大学の学生による有志団体であり、iGEMへの出場およびメダルの獲得を目標としています。iGEM TSUKUBAには様々な学群・学類の学生が集まり、日々研究活動や教育活動に励んでおります。" />

      <Paragraph text="　iGEMは社会に対する生物学の周知の役割にも担っており、我々メンバーは小学生から大人までを対象とした教育活動を日々行っております。また、研究成果を広く利用可能にするためのハードウェアの開発も行っております。このようにiGEMは生物学の研究という側面とともに、社会への生物学の浸透と正しい知識の教示という側面も併せ持ちます。iGEMへの参加を志す団体は筑波大学以外にも東京大学や京都大学など、様々な大学に存在しています。我々は単なる研究活動としてではなく、教育、ビジネス、社会的意義についての思慮を込めながら幅広く活動する方針を続けています。これらの統合によってはじめて成し遂げられることがある、と我々は考えています。" />

      <Paragraph text="　しかしこれら活動を続けていくためには、多額の資金が必要です。研究に必要な資金はもちろん、教育活動のための各地への遠征や大会への参加費や登録費、渡航費、社会活動のための準備資金などは、全て学生たちが用意する必要があります。基本的にこれらは学生たちもしくはその保護者によって賄われている現状です。このような現状が長く続くことは、研究活動として望ましいことではありません。金銭的な事情はコミュニティの継続、チームの存続を不可能にし得るものです。多くの学生にとって直面している困難は、科学的な挑戦そのものではなく、参加のための金銭です。" />

      <Paragraph text="　今後もiGEMチームを存続させていくべく、我々iGEM TSUKUBAはクラウドファンディングを実施します。これはiGEM TSUKUBAが今後も活動を続けていくためのクラウドファンディングです。支援者様にはステッカーやアクリルキーホルダー、Tシャツなどの返礼品を用意しております。皆様からのご厚意とご支援が、今後のiGEM TSUKUBAの存続に直結します。どうかご支援のほどよろしくお願いいたします。クラウドファンディング用ウェブページからご支援いただけます。" />

      <Paragraph text="　ここであえて申し上げたいことは、ぜひとも他iGEMチームのクラウドファンディングにもご協力をお願いしたいということです。資金問題は我々だけの問題ではなく、日本のiGEMチームが広く抱えている問題でもあります。ぜひとも我々iGEM TSUKUBAと、iGEMコミュニティへのご支援をよろしくお願いいたします。" />

      <Button
        label="私たちの活動についてはこちら"
        textColor="#007aff"
        backgroundColor="white"
        link="/about/about_iGEM_TSUKUBA"
      />

      <Paragraph text="*1：2024年8月現在。" />

      <Subtitle text="ご支援の方法について" />

      <Paragraph text="　集まった支援金は以下のような用途に使われます。" />

      <Paragraph text={bulletPoints} isBulletList={true} />

      <Paragraph
        text="　使途についてご不明な点がありましたらお気軽にお問い合わせください。また、定期的にHPやSNS等で活動報告を行う予定ですので、そちらも併せてご確認ください。 
なお、直接のご寄付や物品協賛を希望してくださる方はお手数ですが団体メール宛にご一報いただければと思います。団体へのメールはページ上部のお問い合わせから送ることができます。
            iGEM TSUKUBAへの温かいご支援をよろしくお願いいたします！ "
      />

      <Paragraph text="*2：iGEMでは合成生物学の周辺知識やそれを包括する生物学を一般に広める教育活動が評価対象となっています。" />

      <Subtitle text="過去にいただいたご支援" />

      <Button
        label="プロジェクトページ"
        textColor="#007aff"
        backgroundColor="white"
        link="https://camp-fire.jp/projects/787804/view?utm_campaign=cp_po_share_c_msg_mypage_projects_show"
      />

      <Image
        src="pages/Sponsership/cloudfinding.webp"
        alt="「AI」✖️「合成生物学」で世界へ"
        caption=" "
        width={500}
        height={375}
        borderRadius={0}
        margin="0"
      />

      <Footer />
    </div>
  );
};

export default Sponsorship;
